import {useCallback, useEffect, useRef, useState} from 'react';
import {InputLine} from '../../designComponents/inputs/InputLine';
import {LText, SText} from '../../designComponents/text/ContentText';
import {FlexTwoText} from '../../designComponents/text/TextMapping';
import FlexMainWrapper from '../../designComponents/wrappers/FlexMainWrapper';
import {MainButton} from '../../designComponents/buttons/Buttons';
import RefreshCheckApi from '../../communication_system/axios_apis/refresh_check/refresh_check_api';
import {main_server_ip} from '../../communication_system/communication_ips';
import HorizontalImageLists from '../../designComponents/BeautifulDND/HorizontalImageLists';
import {SelectLine} from '../../designComponents/dropdowns/Selectdown';
import {isEmptyObj} from '../../utils/textFilter';
import CKEditorComponent from '../../components/ProductComponent/ckEditor';
import {DefaultModal} from '../../designComponents/modals/ModalComponent';
import {TextArea} from '../../designComponents/inputs/TextArea';
import {CheckboxList} from '../../designComponents/checkboxs/CheckboxInput';

/** 상품추가 페이지 */
const AddProduct = ({ show, setShow, detail, onSave }) => {
    // 상품 관련 상태
    const productCategory = [
        { id: 0, title: '건강/식품', value: 0 },
        { id: 1, title: '생활/리빙', value: 1 },
        { id: 2, title: '뷰티/케어', value: 2 },
        { id: 3, title: '기타', value: 3 },
    ];
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [listPrice, setListPrice] = useState('');
    const [discountPrice, setDiscountPrice] = useState('');
    const [category, setCategory] = useState(productCategory[0]);
    const [host, setHost] = useState({});
    const [hostLists, setHostLists] = useState([]);
    const [orignHosts, setOrignHosts] = useState([]);
    const [isCreateHost, setIsCreateHost] = useState(false);
    const [availYn, setAvailYn] = useState(true);
    const [adminMemo, setAdminMemo] = useState('');
    // 이미지 및 HTML
    const [imageLists, setImageLists] = useState([]);
    const [html, setHtml] = useState('');

    const imageInput = useRef();

    /** 초기 detail 세팅 */
    useEffect(() => {
        if (detail?.product) {
            console.log(detail);
            const p = detail.product;
            setAdminMemo(p.admin_memo || '');
            setName(p.name || '');
            setDescription(p.promotional_title || '');
            setListPrice(p.list_price || '');
            setAvailYn(p.avail_yn === 1);
            setDiscountPrice(p.discount_price || '');
            console.log(productCategory.find((e) => e.id === p.big_category)?.id);
            setCategory(productCategory.find((e) => e.id === p.big_category)?.id ?? 0);
            setHost({
                ...detail.host,
                value: detail.host.id,
            });
            setImageLists(detail.productImages?.map((e) => e.url) || []);
            setHtml(p.text_info || '');
        } else {
            // 초기화
            setName('');
            setAdminMemo('');
            setDescription('');
            setListPrice('');
            setDiscountPrice('');
            setAvailYn(true);
            setCategory(null);
            setHost({});
            setImageLists([]);
            setHtml('');
        }
    }, [detail]);

    /** 판매처 리스트 불러오기 */
    useEffect(() => {
        RefreshCheckApi.get('/adminProduct/hostInformations').then((response) => {
            const data = response.data.data;
            setOrignHosts(data);
            setHostLists([{ id: 0, title: '판매처를 선택해 주세요', value: 0 }, ...data.map((h) => ({ id: h.id, title: h.name, value: h.id }))]);
        });
    }, []);

    /** 할인율 계산 */
    const percentFilter = (list_price, discount_price) => {
        const _list = parseInt(list_price);
        const _discount = parseInt(discount_price);
        if (_list && _discount) return (100 - (_discount / _list) * 100).toFixed(2);
        return 0;
    };

    /** 이미지 업로드 */
    const onClickImageUpload = () => imageInput.current.click();

    const requestServer = useCallback(async (FormData) => {
        const result = await RefreshCheckApi.post(main_server_ip + '/adminProduct/productImage', FormData);
        setTimeout(() => {
            setImageLists((prev) => [...prev, ...result.data]);
        }, 1000);
    }, []);

    const onChangeImages = useCallback(
        async (e) => {
            const formData = new FormData();
            [].forEach.call(e.target.files, (f) => formData.append('image', f));
            await requestServer(formData);
        },
        [requestServer],
    );

    const getItems = (originData) => originData?.map((url, i) => ({ id: `item-${i}`, content: url })) || [];

    /** 저장 버튼 클릭 시 */
    const handleSubmit = async () => {
        try {
            if (!name.length) return alert('상품명을 입력하세요');
            if (!description.length) return alert('상품 설명을 입력하세요');
            if (isNaN(Number(listPrice))) return alert(`상품 가격을 입력하세요 ${listPrice}`);
            if (isNaN(Number(discountPrice))) return alert('상품 할인가를 입력하세요');
            if (!imageLists.length) return alert('상품 이미지를 추가해주세요.');
            else if (imageLists[0] === 'userPhoto/default.jpg') return alert('상품 이미지를 추가해주세요.');

            if (!host?.name) return alert('판매처를 선택해주세요.');
            const data = {
                name,
                promotional_title: description,
                refund_policy: '정보 없음',
                admin_memo: adminMemo,
                list_price: Math.abs(Number(listPrice)),
                discount_price: Math.abs(Number(discountPrice)),
                host: {
                    ...host,
                    self: isCreateHost,
                },
                text_info: html,
                category,
                image_lists: imageLists,
                options: [],
                avail_yn: availYn ? 1 : 0,
            };
            let response;
            if (detail?.product?.id) {
                data.id = detail.product.id;
                response = await RefreshCheckApi.patch('/adminProduct/update', data);
            } else {
                response = await RefreshCheckApi.post('/adminProduct', data);
            }
            if (response.status === 200) {
                onSave();
                alert('처리되었습니다.');
            }
        } catch (error) {
            console.error('error: ', error);
        }
    };

    return (
        <DefaultModal
            title={`상품 ${detail.product ? '수정' : '등록'}`}
            bodyWidth={79}
            boxStyle={{ width: '100vh', height: '90vh' }}
            onClickClose={() => setShow(false)}
            bottomBtnOn
            saveOn
            show={show}
            closeOn
            saveText={'저장'}
            onClickBottomClose={() => setShow(false)}
            onClickSave={handleSubmit}
        >
            <FlexMainWrapper style={{ flexDirection: 'column', width: '100%', display: 'flex', padding: 10 }}>
                <FlexMainWrapper style={{ alignItems: 'start', padding: '20px', gap: '20px', width: '95.5%' }} mobileOn>
                    {/* 왼쪽 상품 입력 */}
                    <FlexMainWrapper style={{ flexDirection: 'column', width: '50%' }}>
                        <LText text="상품 등록" />
                        <FlexMainWrapper style={{ flexDirection: 'column', width: '100%', marginTop: '15px' }}>
                            <InputLine title="상품명" value={name} onChange={(e) => setName(e.target.value)} />
                            <InputLine title="상품 설명" value={description} onChange={(e) => setDescription(e.target.value)} />
                            <InputLine title="원가" value={listPrice} onChange={(e) => setListPrice(e.target.value)} />
                            <InputLine title="할인가" value={discountPrice} onChange={(e) => setDiscountPrice(e.target.value)} />
                            <InputLine title="할인율" disabled={true} value={`${percentFilter(listPrice, discountPrice)}%`} onChange={(e) => setDiscountPrice(e.target.value)} />

                            <SelectLine
                                title="카테고리"
                                list={productCategory}
                                value={category}
                                resetThenSet={(target) => {
                                    setCategory(target.value);
                                }}
                            />
                            <CheckboxList
                                title={'노출 여부'}
                                wrapperStyle={{ marginTop: '7px', marginBottom: '7px' }}
                                titleStyle={{ width: '58px' }}
                                gap={'10px'}
                                itemLists={[
                                    {
                                        subject: 'Y',
                                        checked: availYn,
                                        onChange: (e) => {
                                            setAvailYn(true);
                                        },
                                    },
                                    {
                                        subject: 'N',
                                        checked: !availYn,
                                        onChange: (e) => {
                                            if (e.target.checked) {
                                                setAvailYn(false);
                                            }
                                        },
                                    },
                                ]}
                            />
                        </FlexMainWrapper>
                    </FlexMainWrapper>

                    {/* 오른쪽 판매처 입력 */}
                    <FlexMainWrapper style={{ flexDirection: 'column', width: '50%' }}>
                        <LText text="판매처 등록" />
                        <FlexMainWrapper style={{ flexDirection: 'column', width: '100%', gap: '20px', marginTop: '15px' }}>
                            {isCreateHost ? (
                                <FlexMainWrapper>
                                    <InputLine title="판매처명" onChange={(e) => setHost({ name: e.target.value })} />
                                    <MainButton text="선택 입력" onClick={() => setIsCreateHost(false)} />
                                </FlexMainWrapper>
                            ) : (
                                <FlexMainWrapper>
                                    <SelectLine
                                        title="판매처명"
                                        list={hostLists}
                                        value={host?.value ?? 0}
                                        resetThenSet={(target) => {
                                            const selected = orignHosts.find((item) => item.id === parseInt(target.value));
                                            setHost(selected);
                                        }}
                                    />
                                    <MainButton text="직접 입력" onClick={() => setIsCreateHost(true)} />
                                </FlexMainWrapper>
                            )}
                            <FlexTwoText
                                text01={'대표자 이름'}
                                text02={isEmptyObj(host) ? host.name : <span style={{ color: '#797979' }}>판매처를 선택해 주세요.</span>}
                                text01Style={{ textAlign: 'start', width: '96px', fontWeight: '500' }}
                            />
                            <FlexMainWrapper style={{ flexDirection: 'column', alignItems: 'start', gap: '10px' }}>
                                <FlexTwoText
                                    text01={'사업장 주소'}
                                    text02={isEmptyObj(host) ? `(${host.zone_code}) ${host.address} ${host.address_detail}` : <span style={{ color: '#797979' }}>00000</span>}
                                    text01Style={{ textAlign: 'start', width: '96px', fontWeight: '500' }}
                                />
                                <FlexMainWrapper>
                                    <SText text={'메모'} style={{ width: '63px', textAlign: 'start', fontWeight: '500' }} color="#797979" />
                                    <TextArea
                                        style={{ flex: 1 }}
                                        value={adminMemo}
                                        placeholder={'내용을 입력하세요.'}
                                        onChange={(e) => {
                                            setAdminMemo(e.target.value);
                                        }}
                                    />
                                </FlexMainWrapper>
                            </FlexMainWrapper>
                        </FlexMainWrapper>
                    </FlexMainWrapper>
                </FlexMainWrapper>
                <FlexMainWrapper style={{ alignItems: 'center', gap: 8, marginTop: 16 }}>
                    <LText text="상품 섬네일" />
                    <input type="file" multiple hidden ref={imageInput} onChange={onChangeImages} accept="image/*" />
                    <MainButton text="이미지 추가" onClick={onClickImageUpload} />
                </FlexMainWrapper>
                <HorizontalImageLists images={getItems(imageLists)} originData={imageLists} onChange={(arr) => setImageLists(arr.body.image_lists)} />
                <FlexMainWrapper style={{ flexDirection: 'column', width: '100%', marginTop: 16 }}>
                    <LText text="상품 설명" />
                    <CKEditorComponent
                        onHtmlChange={setHtml}
                        init={html}
                        onChangeImages={(image) => {
                            setHtml((pre) => {});
                        }}
                    />
                </FlexMainWrapper>
            </FlexMainWrapper>
        </DefaultModal>
    );
};

export default AddProduct;
